module.exports = __webpack_public_path__ + "img/estrategia-logo.018bb722.svg";